import { render, staticRenderFns } from "./ElevatorModel3D.vue?vue&type=template&id=fd0a8530&scoped=true"
import script from "./ElevatorModel3D.vue?vue&type=script&lang=js"
export * from "./ElevatorModel3D.vue?vue&type=script&lang=js"
import style0 from "./ElevatorModel3D.vue?vue&type=style&index=0&id=fd0a8530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0a8530",
  null
  
)

export default component.exports